import { useEffect } from 'react'

const BRAND = 'CryptoChangeK'

/**
 * Заголовок вкладки и признак индексации на маршрут.
 *
 * Заголовок нужен не для красоты: у мерчанта одновременно открыты
 * история, вывод и страница оплаты клиента, и «CryptoChangeK» на всех
 * трёх вкладках означает, что нужную он найдёт перебором — иногда
 * подтвердив вывод не из той.
 *
 * `indexable` снимает `noindex`, поставленный в разметке. Ставится
 * только на витрине: кабинет и страницы оплаты в выдаче не нужны,
 * а платёжная ссылка там ещё и опасна — она одноразовая и содержит
 * номер заявки.
 */
export function useMeta(title: string, indexable = false): void {
  useEffect(() => {
    document.title = title ? `${title} — ${BRAND}` : BRAND
  }, [title])

  useEffect(() => {
    const tag = document.querySelector('meta[name="robots"]')
    if (!tag) return
    const previous = tag.getAttribute('content')
    tag.setAttribute('content', indexable ? 'index, follow' : 'noindex, nofollow')
    // Возврат к запрету при уходе со страницы: переход с витрины
    // в кабинет не должен оставлять разрешение на индексацию.
    return () => { if (previous !== null) tag.setAttribute('content', previous) }
  }, [indexable])
}
